var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 78,
    viewBox: "0 0 63 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.076 2.99932V18.3137C39.076 20.3902 39.076 21.4284 39.4802 22.2215C39.8356 22.9191 40.4028 23.4863 41.1004 23.8418C41.8935 24.2459 42.9318 24.2459 45.0082 24.2459H60.3226M46.4913 42.7836H16.8304M46.4913 57.6141H16.8304M24.2456 27.9532H16.8304M39.076 2H19.7965C13.5671 2 10.4525 2 8.07316 3.21231C5.98027 4.2787 4.2787 5.98027 3.21231 8.07316C2 10.4525 2 13.5671 2 19.7965V58.3556C2 64.585 2 67.6996 3.21231 70.0789C4.2787 72.1718 5.98027 73.8734 8.07316 74.9398C10.4525 76.1521 13.5671 76.1521 19.7965 76.1521H43.5252C49.7545 76.1521 52.8692 76.1521 55.2485 74.9398C57.3414 73.8734 59.043 72.1718 60.1094 70.0789C61.3217 67.6996 61.3217 64.585 61.3217 58.3556V24.2456L39.076 2Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.aeb6a543e1ade14b2853c400e2c101d1.svg";
export { ForwardRef as ReactComponent };